import { useEffect, useState } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { ThemeProvider, useTheme } from 'next-themes'
import HomePage from '@/pages/HomePage'
import BlogPage from '@/pages/BlogPage'
import BlogDetailPage from '@/pages/BlogDetailPage'
import ServiceDetailPage from '@/pages/ServiceDetailPage'
import AdminLogin from '@/pages/admin/AdminLogin'
import AdminLayout from '@/pages/admin/AdminLayout'
import RequireAuth from '@/pages/admin/RequireAuth'
import Dashboard from '@/pages/admin/Dashboard'
import BlogAdmin from '@/pages/admin/BlogAdmin'
import MessagesAdmin from '@/pages/admin/MessagesAdmin'
import { PortfolioAdmin, PartnersAdmin, TestimonialsAdmin } from '@/pages/admin/AdminPages'
import AssistantQAAdmin from '@/pages/admin/AssistantQAAdmin'
import AnalyticsTracker from '@/components/AnalyticsTracker'

export default function App() {
  const [language, setLanguage] = useState('en')
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])
  if (!mounted) return null

  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
      <BrowserRouter>
        <RoutedApp language={language} setLanguage={setLanguage} />
      </BrowserRouter>
    </ThemeProvider>
  )
}

function RoutedApp({ language, setLanguage }) {
  const { theme, setTheme } = useTheme()
  const pageProps = { language, setLanguage, theme, setTheme }

  return (
    <>
      <AnalyticsTracker />
      <Routes>
        <Route path="/" element={<HomePage {...pageProps} />} />
        <Route path="/blog" element={<BlogPage {...pageProps} />} />
        <Route path="/blog/:slug" element={<BlogDetailPage {...pageProps} />} />
        <Route path="/services/:slug" element={<ServiceDetailPage {...pageProps} />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={(
            <RequireAuth>
              <AdminLayout />
            </RequireAuth>
          )}
        >
          <Route index element={<Dashboard />} />
          <Route path="portfolio" element={<PortfolioAdmin />} />
          <Route path="blog" element={<BlogAdmin />} />
          <Route path="partners" element={<PartnersAdmin />} />
          <Route path="testimonials" element={<TestimonialsAdmin />} />
          <Route path="faqs" element={<AssistantQAAdmin />} />
          <Route path="messages" element={<MessagesAdmin />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  )
}
